export default "__VITE_ASSET__BFxbOTBq__"